import { useLocation } from "react-router";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { usePasswordTooltip } from "../../../components/PasswordTooltip/passwordTooltipHooks";
import { useCallback, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import PasswordTooltip from "../../../components/PasswordTooltip/PasswordTooltip";
import FormPasswordEye from "../../../components/FormPasswordEye/FormPasswordEye";
import { createStructuredSelector } from "reselect";
import {
    getPasswordMinLengthSelector,
    getIsCheckCodeLoading,
    makeSelectAppFormError
} from "../../../app/appSelectors";
import { checkCodeAction, passwordUpdateAction } from "../loginActions";
import { connect } from "react-redux";

function ResetPasswordContent(props) {
    const {
        checkCode,
        failureRedirectLink,
        formError,
        onUpdateSuccessCallback,
        passwordMinLength,
        passwordUpdate,
    } = props;
    const location = useLocation();
    const {getLangPath} = useLangContext();
    const {
        isShowPasswordTooltip, checkPasswordValue, onBlurPasswordField, onSelectPasswordField, onChangePasswordField,
    } = usePasswordTooltip();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const email = params.get('email');
        const code = params.get('code');
        checkCode({email, code, failureRedirectLink});
    }, [location.search, checkCode, failureRedirectLink]);

    const submitHandler = useCallback((e) => {
        e.preventDefault();
        const params = new URLSearchParams(location.search);
        const email = params.get('email');
        const code = params.get('code');
        passwordUpdate({
            email: email,
            code: code,
            password: e.target.querySelector('[name=password]').value,
            password2: e.target.querySelector('[name=password2]').value,
            onSuccessCallback: onUpdateSuccessCallback,
        });
    }, [location, onUpdateSuccessCallback, passwordUpdate]);

    return <>
        <h1 className="reset-password-content__title">
            {getLangPath('promo.fx.new_password.title')}
        </h1>
        <Form onSubmit={submitHandler}>
            <PasswordTooltip password={checkPasswordValue} show={isShowPasswordTooltip}>
                <Form.Group className="reset-password-content__password">
                    <FormPasswordEye
                        name="password"
                        placeholder={getLangPath('promo.fx.new_password.title')}
                        isInvalid={formError}
                        required
                        onSelect={onSelectPasswordField}
                        onBlur={onBlurPasswordField}
                        onChange={onChangePasswordField}
                    />
                </Form.Group>
            </PasswordTooltip>
            <Form.Group className="reset-password-content__password-confirm">
                <FormPasswordEye name="password2" placeholder={getLangPath('promo.fx.new_password.text1')}
                                 isInvalid={formError} required/>
                {
                    formError && <>
                        <Form.Control.Feedback type="invalid">
                            {getLangPath(formError, {count: passwordMinLength})}
                        </Form.Control.Feedback>
                    </>
                }
            </Form.Group>

            <div className="d-grid reset-password-content__submit-button">
                <Button variant="primary" size="lg" type="submit">
                    {getLangPath('promo.fx.new_password.button')}
                </Button>
            </div>
        </Form>
    </>
}

const mapStateToProps = createStructuredSelector({
    formError: makeSelectAppFormError(),
    isCheckCodeLoading: getIsCheckCodeLoading,
    passwordMinLength: getPasswordMinLengthSelector,
});

const mapDispatchToProps = (dispatch) => ({
    checkCode: (payload) => dispatch(checkCodeAction(payload)),
    passwordUpdate: (payload) => dispatch(passwordUpdateAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContent);
